export const app = {
  loading: true,
  language: 'en',
  contact: false,
  animating: false,
  navigation: false,
  scroll: undefined,
  pointer: undefined,
  effects: undefined,
  transitions: undefined,
};

export const setLang = () => {
  const locale = `${window.location.pathname.split('/').slice(0, 2).join('/')}/`;
  if (locale === '/it/') {
    app.language = 'it';
  } else {
    app.language = 'en';
  }
};

setLang();

export const slider = {
  app: undefined,
  prev: undefined,
  next: undefined,
  current: undefined,
};

export const webgl = {
  animate: 0,
  pause: false,
  loaded: false,
  app: undefined,
};

export const math = {
  lerp: (a, b, n) => (1 - n) * a + n * b,
};
